import { render, staticRenderFns } from "./OrdersTab.vue?vue&type=template&id=79cf349c&scoped=true&"
import script from "./OrdersTab.vue?vue&type=script&lang=ts&"
export * from "./OrdersTab.vue?vue&type=script&lang=ts&"
import style0 from "./OrdersTab.vue?vue&type=style&index=0&id=79cf349c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cf349c",
  null
  
)

export default component.exports